export abstract class AbstractApiElement {
  id: number = null;
}
